import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

import Selectize from 'selectize/dist/js/selectize'
window.Selectize = Selectize

import Chart from 'chart.js/dist/Chart'
window.Chart = Chart

import L from 'leaflet'
window.L = L

import moment from 'moment'
import 'moment/locale/de'
window.moment = moment
moment.locale('de')

import Rails from '@rails/ujs'
Rails.start()
window.Rails = Rails
